import { Contract, Process } from "@/types/contract";
import { Attachment } from "@/types/enumerations";

export const getAttachmentName = (
  attachments: Attachment[],
  fileTypeCode: string,
  process: Process,
  defaultValue: string = ""
) => {
  const foundAttachment = attachments.find(
    attachment => attachment.value.type === fileTypeCode && attachment.value.processId === process
  );
  return foundAttachment?.nameForCustomers ?? foundAttachment?.name ?? defaultValue;
};

export const getAttachmentDescription = (
  attachments: Attachment[],
  fileTypeCode: string,
  process: Process,
  defaultValue: string = ""
) => {
  const foundAttachment = attachments.find(
    attachment => attachment.value.type === fileTypeCode && attachment.value.processId === process
  );
  return foundAttachment?.descriptions ?? defaultValue;
};

export const getAttachmentByCode = (
  attachments: Attachment[],
  fileTypeCode: string,
  contract: Contract,
  isContractRequest: boolean
) => {
  return attachments.find(
    attachment =>
      attachment.value.type === fileTypeCode &&
      attachment.value.processId === contract.process &&
      attachment.value.commodity === contract.supplyPoint.commodity &&
      (isContractRequest
        ? attachment.value.processReasonId === contract.processReason
        : attachment.value.processReasonId === contract.supplyPoint.previousContract?.processReason)
  );
};
